// Este servicio permite encapsular el llamado a los métodos del api usando solamente el método específico
// sin tener que importart todo de api/index.js. 
// ir colococando en este servicio solo los llamandos relacionados con partidas

import { obtenerFamiliaPorArea, obtenerConceptoPorFamilia, DEVELOP } from "../../api/index"


export const ionPartidasService = () => {

    const getFamiliasFromIONPartidas = async (areaId) => {
        if (!areaId) return [];

        try {
            const res = await obtenerFamiliaPorArea(areaId);

            return res?.map(({ Valor: value, Etiqueta: label }) => ({ value, label })) || [];

        } catch (error) {            
            DEVELOP && console.log(error);

            throw error;
        }
    };

    const getConceptosByFamilia = async (familia, areaId) => {
        if (!familia || !areaId) return [];

        try {            
            const res = await obtenerConceptoPorFamilia({ familia, idArea: areaId });

            return res?.map(({ Valor: value, Etiqueta: label }) => ({ value, label })) || [];

        } catch (error) {
            DEVELOP && console.log(error);
            throw error;
        }
    };

    return {
        getFamiliasFromIONPartidas,
        getConceptosByFamilia
    }
}

